export default __webpack_public_path__ + "media/Seafood-Processed-Seafood.3b1fca25.png";